import { render } from "./client-service.vue?vue&type=template&id=af62896c"
import script from "./client-service.vue?vue&type=script&lang=js"
export * from "./client-service.vue?vue&type=script&lang=js"

import "./client-service.vue?vue&type=style&index=0&id=af62896c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__